import { getPid } from 'exeAction-utils';
import { useUserStore } from '../../store/modules/user';
import { isN, isNN } from '../../utils/tools';


// 为了跨层级组件使用参数  todo 这个地方存的太多了，需要考虑优化 检查调用点
export function setJoinpParam(route: any, did: number, ck: string, cv: any) {
  if (did >= 0 && ck) {
    const userStore = useUserStore();
    let pid = getPid(route);
    let comParmsKs = userStore['comParmsKs'] || {};
    let comParmsVs = userStore['comParmsVs'] || {};
    if (cv && (cv.length > 0 || JSON.stringify(cv).length > 0)) {
      comParmsKs[`${pid}_${did}_k`] = ck;
      comParmsVs[`${pid}_${did}_v`] = cv;
    } else {
      delete comParmsKs[`${pid}_${did}_k`];
      delete comParmsVs[`${pid}_${did}_v`];
    }
    userStore['comParmsKs'] = comParmsKs;
    userStore['comParmsVs'] = comParmsVs;
  }
}



// 使用完全局要删除的参数，在api执行成功后清除
export function delJoinpParam(route, did, ck, cv) {
  if (did >= 0 && ck) {
    const userStroe = useUserStore();
    let pid = getPid(route);
    let comParmsDel = userStroe['comParmsDel'] || {};
    if (cv && cv.length > 0) {
      comParmsDel[`${pid}_${did}_k`] = ck;
    } else {
      delete comParmsDel[`${pid}_${did}_k`];
    }
    userStroe['comParmsDel'] = comParmsDel;
  }
}



/*
用控件自身绑定就可以
  // 使用完全局要删除的参数，在api执行成功后清除
export function sortParam(route:string, did:number, sort:string, isSave:boolean){
    if(did>=0){
        const userStroe = useUserStore();
        let pid = getPid(route);
        let sortParam = userStroe['sortparam'] || {};
        if(isSave) {
          sortParam[pid+'_'+did+'_k_sort'] = sort;
          userStroe['sortparam'] = sortParam;
          return;
        }

        //isSave false表示取消排序，此时返回原始的排序字符
        let oriSort = sortParam[pid+'_'+did+'_k_sort'];
        delete sortParam[pid+'_'+did+'_k_sort'];
        userStroe['sortparam'] = sortParam;
        return oriSort;
     }
}
*/

/*  放到action中处理
  // 使用全局action存储
  // 在导出Excel时如果未提供api，则需要导出当前表的内容，这些内容可能来自prepare
  // 或者来自搜索，重置等按钮。需要将其记住。获取出来该action
  export function setComAction(route,did, prepair){
    let pid = getPid(route);
    const userStroe = useUserStore();
    let comAction = userStroe['comAction'] || {};
    if(did>=0 && prepair && JSON.stringify(prepair) !== '{}'){
      comAction[`${pid}_xls_${did}`] = prepair;
      userStroe['comAction'] = comAction;
    }else{
      delete comAction[`${pid}_action_${did}`];
    }
}*/

// 清理当前菜单公共缓存
export function clearMenuComCache(route) {
  let pid = getPid(route);
  const userStroe = useUserStore();
  const tableColMap = userStroe['tableColMap'];
  if (tableColMap) {
    let tbtemp = {};
    for (let ti in tableColMap) {
      let titem = tableColMap[ti];
      if (ti.startsWith(`${pid}_`)) {
        tbtemp[ti] = titem;
      }
    }
    userStroe['tableColMap'] = tbtemp
  }

  const comParmsKs = userStroe['comParmsKs'];
  if (comParmsKs) {
    let tbtemp = {};
    for (let ti in comParmsKs) {
      let titem = comParmsKs[ti];
      if (ti.startsWith(`${pid}_`)) {
        tbtemp[ti] = titem;
      }
    }
    userStroe['comParmsKs'] = tbtemp
  }

  const comParmsVs = userStroe['comParmsVs'];
  if (comParmsVs) {
    let tbtemp = {};
    for (let ti in comParmsVs) {
      let titem = comParmsVs[ti];
      if (ti.startsWith(`${pid}_`)) {
        tbtemp[ti] = titem;
      }
    }
    userStroe['comParmsVs'] = tbtemp
  }
}


/** detail保留几点几分*/
export function dateAdd(date: any, daysOrWeeks: number, fmt: string) {
  if (!date) {
    date = new Date();
  }

  let newUtcDate: Date;
  if (fmt && fmt.startsWith('{w}')) {
    //fmt要修改下,去掉{w}
    fmt = fmt.replace('{w}', '');

    // 处理周数加减
    const dateObj = new Date(date);
    // 获取当前是周几（0是周日，1是周一...6是周六）
    const dayOfWeek = dateObj.getDay();
    // 计算到上周一的偏移量（如果是周日，dayOfWeek=0，需要-6天）
    const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;

    // 先调整到本周一
    const monday = new Date(dateObj);
    monday.setDate(dateObj.getDate() + daysToMonday);

    // 然后加减周数
    newUtcDate = new Date(monday);
    newUtcDate.setDate(monday.getDate() + (daysOrWeeks * 7));
  } else if (fmt && fmt.startsWith('{M}')) {
    // 加月份逻辑：直接修改 year 和 month，Date 对象会自动处理跨年等问题
    const originalYear = date.getFullYear();
    const originalMonth = date.getMonth(); // 0-11
    const newMonth = originalMonth + daysOrWeeks;
    const newYear = originalYear + Math.floor(newMonth / 12);
    const adjustedMonth = newMonth % 12; // 保证在 0~11 范围内

    newUtcDate = new Date(newYear, adjustedMonth, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());

    // 注意：如果新的月份没有对应的日期（比如 1月31日 -> 2月31日不存在），JS 会自动进位到下个月
    // 如果你希望保持当月的最后一天，可以进一步处理，但你说“只修改年和月就行的数字就行”，所以我们暂时按此处理
  } else if (fmt && fmt.startsWith('{m}')) {
    // 加分钟逻辑：直接修改小时和分钟，Date 对象会自动处理跨小时/跨天等问题
    const originalHours = date.getHours();
    const originalMinutes = date.getMinutes();
    const newMinutes = originalMinutes + daysOrWeeks;
    const newHours = originalHours + Math.floor(newMinutes / 60);
    const adjustedMinutes = newMinutes % 60; // 保证在 0~59 范围内

    newUtcDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(),
      newHours, adjustedMinutes, date.getSeconds());
  } else {
    // 天数加减逻辑
    const utcDate = date.toISOString();
    const daysMills: number = 24 * 60 * 60 * 1000 * daysOrWeeks;
    newUtcDate = new Date(Date.parse(utcDate) + daysMills);
  }

  const day = newUtcDate.toLocaleDateString();//2025/03/12
  const time = newUtcDate.toTimeString();//23:34:12 GMT+08.....

  if (fmt === 'd') {
    return day;
  }
  if (fmt === 'ds') {
    return `${day} 00:00:00`;
  }
  if (fmt === 'de') {
    return `${day} 23:59:59`;
  }

  if (fmt === 'Ms') {
    // 当月第一天的 00:00:00
    const year = newUtcDate.getFullYear();
    const month = (newUtcDate.getMonth() + 1).toString().padStart(2, '0');
    return `${year}-${month}-01 00:00:00`;
  }
  if (fmt === 'Me') {
    // 当月最后一天的 23:59:59
    const year = newUtcDate.getFullYear();
    const month = newUtcDate.getMonth(); // 0-11
    const lastDay = new Date(year, month + 1, 0).getDate();
    const monthStr = (month + 1).toString().padStart(2, '0');
    const lastDayStr = lastDay.toString().padStart(2, '0');
    return `${year}-${monthStr}-${lastDayStr} 23:59:59`;
  }

  if (fmt === 'Ws') {
    // 本周周一的 00:00:00
    const year = newUtcDate.getFullYear();
    const month = newUtcDate.getMonth();
    const date = newUtcDate.getDate();
    const dayOfWeek = newUtcDate.getDay();
    const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const monday = new Date(year, month, date + daysToMonday);
    return `${monday.getFullYear()}-${(monday.getMonth() + 1).toString().padStart(2, '0')}-${monday.getDate().toString().padStart(2, '0')} 00:00:00`;
  }
  if (fmt === 'We') {
    // 本周周日的 23:59:59
    const year = newUtcDate.getFullYear();
    const month = newUtcDate.getMonth();
    const date = newUtcDate.getDate();
    const dayOfWeek = newUtcDate.getDay();
    const daysToSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
    const sunday = new Date(year, month, date + daysToSunday);
    return `${sunday.getFullYear()}-${(sunday.getMonth() + 1).toString().padStart(2, '0')}-${sunday.getDate().toString().padStart(2, '0')} 23:59:59`;
  }

  //如下意思是：仅保留到小时，分钟整数
  if (fmt === 'h') {
    return `${day} ${time.split(':')[0]}:00:00`;
  }
  if (fmt === 'm') {
    let ts = time.split(':');
    return `${day} ${ts[0]}:${ts[1]}:00`;
  }
  if (fmt === 'M') {
    // 将 "2025/03/12" 格式转换为 "2025-03-01 00:00:00"
    const dateParts = day.split('/');
    if (dateParts.length >= 2) {//应该是3
      const year = dateParts[0];
      const month = dateParts[1].padStart(2, '0');
      return `${year}-${month}`;
    }
    // 备用方案：如果格式不符合预期
    return `${day.replace(/\//g, '-').substring(0, 7)}`;
  }

  //s
  return `${day} ${time}`;
}

/** 将 2022-07-26 14:32:36.2222按照类似yyyy-MM-dd HH:mm:ss去格式化*/
export function formatDate(date: any, formater: any) {
  if (!date) {
    return '-- : --'
  }
  // 使用正则匹配, 否则会导致replace额外的数据
  date = date.toString().replace(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2}(?:\.\d+)?)/g, '$1 $2');  // 先把 T 替换为空格
  date = date.replace(/-/g, '/')            // 再把 - 替换为 /
  let nowDate = new Date(date)
  let year: any = nowDate.getFullYear()
  let month: any = nowDate.getMonth() + 1
  month = month < 10 ? `0${month}` : month
  let day: any = nowDate.getDate()
  day = day < 10 ? `0${day}` : day
  let hour: any = nowDate.getHours()
  hour = hour < 10 ? `0${hour}` : hour
  let minute: any = nowDate.getMinutes()
  minute = minute < 10 ? `0${minute}` : minute
  let second: any = nowDate.getSeconds()
  second = second < 10 ? `0${second}` : second
  let rtn = `${year}-${month}-${day}`
  let week: any = nowDate.getDay();
  let weeks = [
    "周日",
    "周一",
    "周二",
    "周三",
    "周四",
    "周五",
    "周六"
  ];
  week = weeks[week];
  if (formater) {
    rtn = formater
      .replace('yyyy', year)
      .replace('MM', month)
      .replace('dd', day)
      .replace('HH', hour)
      .replace('mm', minute)
      .replace('ss', second)
      .replace('week', week)

  }
  return rtn
}


//将常见的日期字符串转换为 Date 对象
export function str2Date(dateString: string): Date {
  // 移除前后空格
  const trimmed = dateString.trim();

  // 尝试直接解析（适用于ISO格式）
  const directParse = new Date(trimmed);
  if (!isNaN(directParse.getTime())) {
    return directParse;
  }

  // 处理常见的分隔符格式
  const normalized = trimmed
    .replace(/\//g, '-')  // 统一使用 - 作为分隔符
    .replace(/\s+/, 'T')  // 将空格替换为 T
    .replace(/T(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?/, 'T$1:$2:$3');

  // 补全缺失的部分
  let finalString = normalized;
  const parts = normalized.split('-');

  if (parts.length === 2) {
    // YYYY-MM 格式，补全日
    finalString = `${normalized}-01`;
  }

  if (parts.length === 1 && /^\d{6}$/.test(normalized)) {
    // YYYYMM 格式
    finalString = `${normalized.substring(0, 4)}-${normalized.substring(4, 6)}-01`;
  }

  // 尝试解析补全后的字符串
  const parsedDate = new Date(finalString);
  if (!isNaN(parsedDate.getTime())) {
    return parsedDate;
  }

  return null;
}

/* 需要浏览器支持
const formatter = new Intl.DateTimeFormat('zh-CN', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  fractionalSecondDigits: 3,
});*/
/** formatter.format(null, true)*/
export function timeStr(date: Date, hasMs: boolean): string {
  if (date == null) { date = new Date(); };

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  if (hasMs) {
    const ms = String(date.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${ms}  `;
  }
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}  `;
};


export function visibiltyItem(attr: any, paramFormData: any, autoMap: any) {
  if (isN(attr['vf'])) {
    return true;
  }

  //异常的，全都不可视，尽量权限最小化
  if (!Array.isArray(attr['vf'])) {
    return false;
  }

  //至少有值，没值不显示
  let vfs = attr['vf'][0]['{v}'];
  if (!Array.isArray(vfs) || vfs.length === 0) {
    return false;
  }

  //针对不同模式
  let v = false;
  //接下来，满足该项的值，要执行角色等过滤
  let sys: any;
  let seg: any;
  let itm: any;
  for (let one of vfs) {
    //l-uinfo.mail,ew,@a.com
    sys = one.split(',');//l-uinfo.mail ew @a.com
    seg = sys[0].split('-');//l-uinfo.mail
    itm = seg[1].split('.');//uinfo mail
    if (seg[0] === 'p') {//localStorage
      let jsSeg = autoMap[itm[0]] ? `${autoMap[itm[0]][itm[1]]}` : undefined;
      if (isNN(jsSeg) && itm.length === 2) {//多段
        switch (sys[1]) {
          case '{=}':
            if (jsSeg === sys[2]) {
              v = true;
            }
            break;
          case '{ew}':
            if (`${autoMap[itm[0]][itm[1]]}`.endsWith(sys[2])) {
              v = true;
            }
            break;
          case '{c}':
            if (jsSeg.includes(sys[2])) {
              v = true;
            }
            break;
          case '{ne}'://eq
            if (autoMap[itm[0]][itm[1]] !== sys[2]) {
              v = true;
            }
            break;
          default://eq
            if (autoMap[itm[0]][itm[1]] === sys[2]) {
              v = true;
            }
            break;
        }//switch
      }//itm 2
    } else if (seg[0] === '[fk]') {// 通过paramFormData传过来的参数进行判断
      switch (sys[1]) {
        case '{n}':// 为空返回真
          if (isN(paramFormData[itm[0]])) {
            v = true;
          }
          break;
        case '{nn}':// 不为空返回真
          if (isNN(paramFormData[itm[0]])) {
            v = true;
          }
          break;
        default:
          if (paramFormData[itm[0]] === sys[2]) {
            v = true;
          }
      }
    } else if (seg[0] === '[t]') {//实现类似今天到明天不能看见哪个组件这种
      //来自时间[{"{v}", new String[] {"[t]-[d],{ge},01","[t]-[d],{le},23"}]
      const today = new Date();
      if (itm[0] === '[d]') {//只关注日
        const dayNumber = today.getDate();
        if (sys[1] === '{ge}') {
          if (dayNumber >= Number(sys[2])) {
            v = true;
          }
        } else if (sys[1] === '{gt}') {
          if (dayNumber > Number(sys[2])) {
            v = true;
          }
        } else if (sys[1] === '{le}') {
          if (dayNumber <= Number(sys[2])) {
            v = true;
          }
        } else if (sys[1] === '{lt}') {
          if (dayNumber < Number(sys[2])) {
            v = true;
          }
        }
      }
    }

    //如果改变了，立即退出即可
    if (v) {
      return v;
    }
  }//for

  return v;
}


//todo 应该是有一个vf/vi规则，满足时/不满足时，该如何作用（样式）：是否展示、是否禁用、颜色如何

export function enableCondition(attr: any, paramFormData: any) {
  const userStore = useUserStore();
  const autoMap = {
    rool: userStore.rool,
    uinfo: userStore.uinfo,
  };


  if (isN(attr['ec'])) {
    return true;
  }

  //异常的，全都不可视，尽量权限最小化
  if (!Array.isArray(attr['ec'])) {
    return false;
  }

  //至少有值，没值不显示
  let vfs = attr['ec'][0]['{v}'];
  if (!Array.isArray(vfs) || vfs.length === 0) {
    return false;
  }

  //针对不同模式
  let v = false;
  //接下来，满足该项的值，要执行角色等过滤
  let sys: any;
  let seg: any;
  let itm: any;
  //这个逻辑是只要满足其中一个就行(or)
  for (let one of vfs) {
    //l-uinfo.mail,ew,@a.com
    sys = one.split(',');//l-uinfo.mail ew @a.com
    seg = sys[0].split('-');//l-uinfo.mail
    itm = seg[1].split('.');//uinfo mail
    if (seg[0] === 'p') {//localStorage
      let jsSeg = autoMap[itm[0]] ? `${autoMap[itm[0]][itm[1]]}` : undefined;
      if (isNN(jsSeg) && itm.length === 2) {//多段
        switch (sys[1]) {
          case '{=}':
            if (jsSeg === sys[2]) {
              v = true;
            }
            break;
          case '{ew}':
            if (`${autoMap[itm[0]][itm[1]]}`.endsWith(sys[2])) {
              v = true;
            }
            break;
          case '{c}':
            if (jsSeg.includes(sys[2])) {
              v = true;
            }
            break;
          case '{ne}'://eq
            if (autoMap[itm[0]][itm[1]] !== sys[2]) {
              v = true;
            }
            break;
          default://eq
            if (autoMap[itm[0]][itm[1]] === sys[2]) {
              v = true;
            }
            break;
        }//switch
      }//itm 2
    } else if (seg[0] === '[fk]') {// 通过paramFormData传过来的参数进行判断
      switch (sys[1]) {
        case '{n}':// 为空返回真
          if (isN(paramFormData[itm[0]])) {
            v = true;
          }
          break;
        case '{nn}':// 不为空返回真
          if (isNN(paramFormData[itm[0]])) {
            v = true;
          }
          break;
        default:
          if (paramFormData[itm[0]] === sys[2]) {
            v = true;
          }
      }
    }

    //如果改变了，立即退出即可
    if (v) {
      return v;
    }
  }//for

  return v;
}

export function validItemVi(viValues: any, routeParams: any, input: any, body: any, rspValue: any, isAnd: boolean) {
  let vAll = false;
  if (Array.isArray(viValues) && viValues.length > 0) {
    for (let viItem of viValues) {
      let v: boolean;
      if (viItem.startsWith('{and}')) {
        v = validItem(viItem.replace('{and}', '').split(';'), routeParams, input, body, rspValue, true);
      } else {
        v = validItem(viItem.replace('{or}', '').split(';'), routeParams, input, body, rspValue, false);
      }
      if (isAnd) {
        vAll = v;
        //and条件。如果v有一次是false，后面就不必检测了
        if (!vAll) {
          break;
        }
      } else {//or条件
        vAll = v || vAll;
        //只要有一个true就不用继续了
        if (vAll) {
          break;
        }
      }

    }
  }

  return vAll;
}
//校验缓存，路由参数，输入input, body，response的值是否满足
//[r]-x,{eq},3 取rsp的x值，判断==3
export function validItem(vivfs: any, routeParams: any, input: any, body: any, rspValue: any, isAnd: boolean) {
  const userStore = useUserStore();
  const autoMap = {
  rool: userStore.rool,
  uinfo: userStore.uinfo,
};

  let vAll = false;
  if (Array.isArray(vivfs) && vivfs.length > 0) {
    //接下来，满足该项的值，要执行角色等过滤
    let sys: any;
    let sysFlag: any;
    let seg: any;
    let itm: any;

    for (let vf of vivfs) {
      let v = false;
      //[t]-[d],{ge},01 sys[1]-[d], {gt}, sys[2]-01
      sys = `${vf}`.split(',');//l-uinfo.mail {ew} @a.com
      sysFlag = sys[0].substring(0, 2);//取前两个字段，
      //出来类似：l uinfo.mail  |  u 603  | [r] x
      seg = sys[0].split('-');

      switch (sysFlag) {
        case 'l-':
          itm = seg[1].split('.');//uinfo mail
          if (itm.length === 2) {
            v = validItemTrueFalse(sys[1], autoMap[itm[0]][itm[1]], sys[2]);
          } else {
            v = validItemTrueFalse(sys[1], autoMap[itm[0]], sys[2]);
          }
          break;
        case 'r-'://u 603{=},1类似，取body
          v = validItemTrueFalse(sys[1], routeParams[seg[1]], sys[2]);
          break;
        case '[r'://[r]-x,{!=},0类似，取response
          v = validItemTrueFalse(sys[1], rspValue[seg[1]], sys[2]);
          break;
        case '[i':
          v = validItemTrueFalse(sys[1], input[seg[1]], sys[2]);
          break;
        case '[b':
          v = validItemTrueFalse(sys[1], body[seg[1]], sys[2]);
          break;
        case '[t'://[t]-[d],{ge},01
          let ori: any;
          if (seg[1] === '[d]') {
            ori = new Date().getDate();
          }
          v = validItemTrueFalse(sys[1], ori, sys[2]);
          break;
        default:
          break
      }

      if (isAnd) {
        vAll = v;
        //and条件。如果v有一次是false，后面就不必检测了
        if (!vAll) {
          break;
        }
      } else {//or条件，需要每个都为true才为true
        vAll = v || vAll;
        //只要有一个true就不用继续了
        if (vAll) {
          break;
        }
      }
    }//for
  }

  return vAll;
}

function validItemTrueFalse(exp: string, ori: any, dst: any) {
  switch (exp) {
    case '{in}':
    case '{c}':
      return `${ori}`.includes(dst);
    case '{eq}'://与下个相同
    case '{=}'://转为字符串比较
      return `${ori}` === `${dst}`;
    case '{!=}':
    case '{ne}':
      return `${ori}` !== dst;
    case '{ew}':
      return `${ori}`.endsWith(dst);
    case '{sw}':
      return `${ori}`.startsWith(dst);
    case '{nin}':
    case '{nc}':
      return !`${ori}`.includes(dst);
    case '{>}':
    case '{gt}':
      return Number(ori) > Number(dst);
    case '{>=}':
    case '{ge}':
      return Number(ori) >= Number(dst);
    case '{<}':
    case '{lt}':
      return Number(ori) < Number(dst);
    case '{<=}':
    case '{le}':
      return Number(ori) <= Number(dst);
    default:
      return false;
  }//switch
}

interface SortConfig<T> {
  key: keyof T;
  asc: boolean;
}

// 泛型排序函数
export const sortByKey = <T>(array: T[], { key, asc }: SortConfig<T>): T[] => {
  return [...array].sort(createComparator(key, asc));
};

/**
 * 排序数组并排除头部和尾部的指定个数的元素
 * @param array - 需要排序的数组
 * @param excludeH - 排除头部的个数
 * @param excludeT - 排除尾部的个数
 * @param {key,asc} - 排序规则（key:排序字段，asc:升序还是降序）
 * @returns 排序后的数组
 */
export const sortByKeyExclude = <T>(
  array: T[],
  excludeH: number,
  excludeT: number,
  reIndexKey: string,
  { key, asc }: SortConfig<T>
): T[] => {
  // 边界检查
  excludeH = Math.max(0, excludeH);
  excludeT = Math.max(0, excludeT);
  if (excludeH + excludeT >= array.length) {
    let result = [...array];
    reindexArray(result, reIndexKey);
    return result;
  }

  // 分割数组
  const result = [...array];
  const sortStart = excludeH;
  const sortEnd = result.length - excludeT;
  const sortLength = sortEnd - sortStart;

  // 性能优化：如果无需排序直接返回
  if (sortLength <= 1) return result;

  // 排序中间部分
  const sortablePart = result.slice(sortStart, sortEnd);
  sortablePart.sort(createComparator(key, asc));

  // 写回排序结果--导致排序结果翻倍
  //result.splice(sortStart, sortLength, ...sortablePart);
  //return result;
  // 重新组合数组（避免使用 splice 导致的问题）
  let result1 = [
    ...result.slice(0, sortStart),
    ...sortablePart,
    ...result.slice(sortEnd)
  ];
  reindexArray(result1, reIndexKey);
  return result1;
};

// 提取比较器生成函数
const createComparator = <T, K extends keyof T>(key: K, asc: boolean) =>
  (a: T, b: T) => {
    const valA = a[key];
    const valB = b[key];

    // 处理null/undefined
    if (valA == null) return 1;
    if (valB == null) return -1;

    // 1. 优先检查数字类型（最可能的情况）
    if (typeof valA === 'number' && typeof valB === 'number') {
      return asc ? valA - valB : valB - valA;
    }

    // 2. 检查是否是百分数字符串（次可能的情况）
    const isPercentString = (value: unknown): value is string =>
      typeof value === 'string' && /^-?\d+\.?\d*%$/.test(value);

    if (isPercentString(valA) && isPercentString(valB)) {
      const numA = parseFloat(valA) / 100;
      const numB = parseFloat(valB) / 100;
      return asc ? numA - numB : numB - numA;
    }

    // 3. 智能数值比较（处理字符串数字、数字字符串等）
    const numA = Number(valA);
    const numB = Number(valB);
    if (!isNaN(numA) && !isNaN(numB) && typeof valA !== 'boolean' && typeof valB !== 'boolean') {
      return asc ? numA - numB : numB - numA;
    }

    // 4. 日期类型比较
    if (valA instanceof Date && valB instanceof Date) {
      const timeA = valA.getTime();
      const timeB = valB.getTime();
      return asc ? timeA - timeB : timeB - timeA;
    }

    // 5. 字符串比较（添加类型保护）
    if (typeof valA === 'string' && typeof valB === 'string') {
      return asc ? valA.localeCompare(valB) : valB.localeCompare(valA);
    }

    // 6. 默认比较
    return asc ? (valA < valB ? -1 : 1) : (valA > valB ? -1 : 1);
  };


/**
 * 高性能重新编号（直接修改数组）
 */
const reindexArray = <T>(array: T[], key: string): void => {
  //如果没有该属性直接返回
  if (!array[0]?.hasOwnProperty(key)) return;
  for (let i = 0; i < array.length; i++) {
    (array[i] as Record<keyof T, any>)[key] = i + 1;
  }
};




// 将值传给父控件，触发父控件的相关事件 新增公共函数传递 给from表单数据
export function emits2Parent(key: string, v: any, emits: any) {
  //attr[k]有值，设置了key才会向外传递，否则传了没处接收
  if (isNN(key)) {
    let emobj = {};
    emobj[key] = v;
    //setTimeout(() => {
    emits('onChange', emobj);
    //});
  }
}

